import { useLocation } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';

const useNavigatedFromDetailToList = () => {
  const location = useLocation();
  const [wentFromDetailToList, setWentFromDetailToList] = useState(false);
  // Explicitly annotate the ref type as string[]
  const previousSegments = useRef<string[]>([]);

  useEffect(() => {
    // Split the pathname into segments and filter out empty strings
    const segments = location.pathname.split('/').filter(Boolean);

    if (previousSegments.current.length) {
      const prevLength = previousSegments.current.length;
      const currLength = segments.length;

      // If we had more segments before (detail view) and now fewer (list view), flag the change.
      if (prevLength > currLength && previousSegments.current[0] === segments[0]) {
        setWentFromDetailToList(true);
      } else {
        setWentFromDetailToList(false);
      }
    }

    previousSegments.current = segments;
  }, [location]);

  return wentFromDetailToList;
};

export default useNavigatedFromDetailToList;
